export const defaultState = {
  collection_paginated: {
    loading: {}
  },
  pages: {
    loading: {}
  }
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case "UPDATE_ROW":
      let matchKey = "";

      if (action.matchKey) {
        matchKey = action.matchKey;
      } else {
        // find Key that match Redux store resource rows and action payloads (match key must contain id)
        matchKey = findIDKey(newState.collection_paginated[action.resource][0], action.payload[0]);
      }
      // updates rows that need to be updated
      const updatedCollection = newState.collection_paginated[action.resource].map(row => {
        const update = action.payload.find(item => {
          return item[matchKey] === row[matchKey]
        });
        if (update) {
          const updatedRow = Object.assign({}, row, update);
          return updatedRow;
        }
        return row
      });

      //update state
      newState.collection_paginated[action.resource] = updatedCollection;

      return newState;

    case "CHANGE_EXISTING_PAGE":
      newState.pages[action.resource] = {
        ...newState.pages[action.resource],
        current_page: action.page
      };
      return newState;

    case "CLEAR_PAGINATION":
      newState.collection_paginated[action.resource] = [];
      newState.pages[action.resource] = {};
      //newState.pages.loading[action.resource] = true;
      return newState;


    case "REQUEST_PAGE":
      newState.collection_paginated.loading[action.resource] = true;
      newState.pages.loading[action.resource] = true;
      return newState;

    case "RECEIVE_PAGE":

      // console.log(action.payload, action.resource);

      if (!(action.resource in newState.collection_paginated)) {
        newState.collection_paginated[action.resource] = [];
      }
      if (!(action.resource in newState.pages)) {
        newState.pages[action.resource] = {};
      }
      newState.collection_paginated.loading[action.resource] = false;
      newState.pages.loading[action.resource] = false;
      newState.pages[action.resource]["order"] = action.payload.order;
      newState.pages[action.resource]["current_page"] = action.payload.page;
      newState.pages[action.resource]["total_items"] = action.payload.total_items;
      newState.collection_paginated[action.resource] = [
        ...newState.collection_paginated[action.resource],
        ...action.payload.results
      ];

      newState.pages[action.resource][action.payload.page] = action.payload.results.map(item => item.id);

      return newState;

    case "ERROR_PAGE":
      newState.collection_paginated.loading[action.resource] = false;
      newState.pages.loading[action.resource] = false;
      return newState;

    default:
      return state
  }
};

const findIDKey = (obj1, obj2) => {
  // return first that intersect both obj and that contains 'id'
  const obj1Keys = Object.keys(obj1);
  const obj2Keys = Object.keys(obj2);

  const key = obj1Keys.filter(x => {
    if (obj2Keys.includes(x)) {
      return x.includes('id')
    } else {
      return false;
    }
  });

  return key[0];

};


// WEBPACK FOOTER //
// ./src/reducers/paginator.js